__turbopack_context__.v({
  "actions": "Fetch-module__VfhDMG__actions",
  "benefit": "Fetch-module__VfhDMG__benefit",
  "benefitCheck": "Fetch-module__VfhDMG__benefitCheck",
  "benefits": "Fetch-module__VfhDMG__benefits",
  "benefitsChevron": "Fetch-module__VfhDMG__benefitsChevron",
  "benefitsToggle": "Fetch-module__VfhDMG__benefitsToggle",
  "closeBtn": "Fetch-module__VfhDMG__closeBtn",
  "comboBox": "Fetch-module__VfhDMG__comboBox",
  "comboEmpty": "Fetch-module__VfhDMG__comboEmpty",
  "comboInput": "Fetch-module__VfhDMG__comboInput",
  "comboList": "Fetch-module__VfhDMG__comboList",
  "comboOption": "Fetch-module__VfhDMG__comboOption",
  "comboOptionActive": "Fetch-module__VfhDMG__comboOptionActive",
  "comboOptionSelected": "Fetch-module__VfhDMG__comboOptionSelected",
  "comboPopup": "Fetch-module__VfhDMG__comboPopup",
  "confirmActions": "Fetch-module__VfhDMG__confirmActions",
  "confirmActionsMobile": "Fetch-module__VfhDMG__confirmActionsMobile",
  "confirmBody": "Fetch-module__VfhDMG__confirmBody",
  "confirmCard": "Fetch-module__VfhDMG__confirmCard",
  "confirmCheck": "Fetch-module__VfhDMG__confirmCheck",
  "confirmHeading": "Fetch-module__VfhDMG__confirmHeading",
  "confirmHeadingMobile": "Fetch-module__VfhDMG__confirmHeadingMobile",
  "confirmHeadline": "Fetch-module__VfhDMG__confirmHeadline",
  "confirmMobile": "Fetch-module__VfhDMG__confirmMobile",
  "confirmRow": "Fetch-module__VfhDMG__confirmRow",
  "coverageAdjustNote": "Fetch-module__VfhDMG__coverageAdjustNote",
  "coverageCard": "Fetch-module__VfhDMG__coverageCard",
  "coverageChip": "Fetch-module__VfhDMG__coverageChip",
  "coverageFinePrint": "Fetch-module__VfhDMG__coverageFinePrint",
  "coverageLink": "Fetch-module__VfhDMG__coverageLink",
  "coveragePlanName": "Fetch-module__VfhDMG__coveragePlanName",
  "coveragePrice": "Fetch-module__VfhDMG__coveragePrice",
  "coveragePriceWrap": "Fetch-module__VfhDMG__coveragePriceWrap",
  "fetchLogoImg": "Fetch-module__VfhDMG__fetchLogoImg",
  "field": "Fetch-module__VfhDMG__field",
  "fieldBox": "Fetch-module__VfhDMG__fieldBox",
  "fieldInput": "Fetch-module__VfhDMG__fieldInput",
  "fieldLabel": "Fetch-module__VfhDMG__fieldLabel",
  "fieldRow": "Fetch-module__VfhDMG__fieldRow",
  "fieldSelect": "Fetch-module__VfhDMG__fieldSelect",
  "fieldSelectPlaceholder": "Fetch-module__VfhDMG__fieldSelectPlaceholder",
  "fields": "Fetch-module__VfhDMG__fields",
  "form": "Fetch-module__VfhDMG__form",
  "hero": "Fetch-module__VfhDMG__hero",
  "heroThumb": "Fetch-module__VfhDMG__heroThumb",
  "iframeMount": "Fetch-module__VfhDMG__iframeMount",
  "input": "Fetch-module__VfhDMG__input",
  "legalDivider": "Fetch-module__VfhDMG__legalDivider",
  "legalLink": "Fetch-module__VfhDMG__legalLink",
  "legalRow": "Fetch-module__VfhDMG__legalRow",
  "loadingBody": "Fetch-module__VfhDMG__loadingBody",
  "loadingText": "Fetch-module__VfhDMG__loadingText",
  "mobile": "Fetch-module__VfhDMG__mobile",
  "mobileWrapper": "Fetch-module__VfhDMG__mobileWrapper",
  "modal": "Fetch-module__VfhDMG__modal",
  "modalPad": "Fetch-module__VfhDMG__modalPad",
  "offerBar": "Fetch-module__VfhDMG__offerBar",
  "offerCopy": "Fetch-module__VfhDMG__offerCopy",
  "offerForm": "Fetch-module__VfhDMG__offerForm",
  "offerFormHeading": "Fetch-module__VfhDMG__offerFormHeading",
  "offerHeading": "Fetch-module__VfhDMG__offerHeading",
  "offerPanel": "Fetch-module__VfhDMG__offerPanel",
  "offerPanelHead": "Fetch-module__VfhDMG__offerPanelHead",
  "offerSub": "Fetch-module__VfhDMG__offerSub",
  "overlay": "Fetch-module__VfhDMG__overlay",
  "petBody": "Fetch-module__VfhDMG__petBody",
  "petMobile": "Fetch-module__VfhDMG__petMobile",
  "petMobileFooter": "Fetch-module__VfhDMG__petMobileFooter",
  "petMobileForm": "Fetch-module__VfhDMG__petMobileForm",
  "petMobileFormHeading": "Fetch-module__VfhDMG__petMobileFormHeading",
  "petMobileHeader": "Fetch-module__VfhDMG__petMobileHeader",
  "petMobileHeading": "Fetch-module__VfhDMG__petMobileHeading",
  "petMobileHero": "Fetch-module__VfhDMG__petMobileHero",
  "petMobileIntro": "Fetch-module__VfhDMG__petMobileIntro",
  "petMobileLogo": "Fetch-module__VfhDMG__petMobileLogo",
  "petMobileScroll": "Fetch-module__VfhDMG__petMobileScroll",
  "petScreen": "Fetch-module__VfhDMG__petScreen",
  "planSummary": "Fetch-module__VfhDMG__planSummary",
  "planSummaryEdit": "Fetch-module__VfhDMG__planSummaryEdit",
  "purchaseBody": "Fetch-module__VfhDMG__purchaseBody",
  "purchaseLoading": "Fetch-module__VfhDMG__purchaseLoading",
  "purchaseScreen": "Fetch-module__VfhDMG__purchaseScreen",
  "radio": "Fetch-module__VfhDMG__radio",
  "seeBenefits": "Fetch-module__VfhDMG__seeBenefits",
  "seeBenefitsChevron": "Fetch-module__VfhDMG__seeBenefitsChevron",
  "seeBenefitsLabel": "Fetch-module__VfhDMG__seeBenefitsLabel",
  "speciesCheck": "Fetch-module__VfhDMG__speciesCheck",
  "speciesIcon": "Fetch-module__VfhDMG__speciesIcon",
  "speciesLabel": "Fetch-module__VfhDMG__speciesLabel",
  "speciesOption": "Fetch-module__VfhDMG__speciesOption",
  "speciesOptionMain": "Fetch-module__VfhDMG__speciesOptionMain",
  "speciesOptionSelected": "Fetch-module__VfhDMG__speciesOptionSelected",
  "speciesRow": "Fetch-module__VfhDMG__speciesRow",
  "sponsoredChip": "Fetch-module__VfhDMG__sponsoredChip",
  "srOnly": "Fetch-module__VfhDMG__srOnly",
  "stickyActions": "Fetch-module__VfhDMG__stickyActions",
  "success": "Fetch-module__VfhDMG__success",
  "successBack": "Fetch-module__VfhDMG__successBack",
  "successBody": "Fetch-module__VfhDMG__successBody",
  "successCheck": "Fetch-module__VfhDMG__successCheck",
  "successHeading": "Fetch-module__VfhDMG__successHeading",
  "successText": "Fetch-module__VfhDMG__successText",
  "teaser": "Fetch-module__VfhDMG__teaser",
  "teaserActions": "Fetch-module__VfhDMG__teaserActions",
  "teaserBody": "Fetch-module__VfhDMG__teaserBody",
  "teaserCard": "Fetch-module__VfhDMG__teaserCard",
  "teaserCopy": "Fetch-module__VfhDMG__teaserCopy",
  "teaserCopyCentered": "Fetch-module__VfhDMG__teaserCopyCentered",
  "teaserDecline": "Fetch-module__VfhDMG__teaserDecline",
  "teaserDeclineLink": "Fetch-module__VfhDMG__teaserDeclineLink",
  "teaserHeading": "Fetch-module__VfhDMG__teaserHeading",
  "teaserLogoCard": "Fetch-module__VfhDMG__teaserLogoCard",
  "teaserMobile": "Fetch-module__VfhDMG__teaserMobile",
  "teaserRow": "Fetch-module__VfhDMG__teaserRow",
  "teaserSub": "Fetch-module__VfhDMG__teaserSub",
  "teaserSubCentered": "Fetch-module__VfhDMG__teaserSubCentered",
  "teaserSubheading": "Fetch-module__VfhDMG__teaserSubheading",
  "teaserTitle": "Fetch-module__VfhDMG__teaserTitle",
  "teaserTitleCentered": "Fetch-module__VfhDMG__teaserTitleCentered",
});
